var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "core-js/modules/es6.array.fill", "@babel/runtime-corejs2/helpers/toConsumableArray", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "date-fns", "date-fns/locale/en-GB", "emotion-theming", "prop-types", "react", "../../../../breakpoints", "../../themes", "../../UI/Icon/ArrowLeft", "../../UI/Icon/ArrowRight", "../RedirectionAnchor/RedirectionAnchor", "./GuideDaySlide", "./GuideDaySlider.css", "../../../../dateHelpers", "@date-fns/upgrade/v2"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("core-js/modules/es6.array.fill"), require("@babel/runtime-corejs2/helpers/toConsumableArray"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("date-fns"), require("date-fns/locale/en-GB"), require("emotion-theming"), require("prop-types"), require("react"), require("../../../../breakpoints"), require("../../themes"), require("../../UI/Icon/ArrowLeft"), require("../../UI/Icon/ArrowRight"), require("../RedirectionAnchor/RedirectionAnchor"), require("./GuideDaySlide"), require("./GuideDaySlider.css"), require("../../../../dateHelpers"), require("@date-fns/upgrade/v2"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.es6Array, global.toConsumableArray, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.dateFns, global.enGB, global.emotionTheming, global.propTypes, global.react, global.breakpoints, global.themes, global.ArrowLeft, global.ArrowRight, global.RedirectionAnchor, global.GuideDaySlide, global.GuideDaySlider, global.dateHelpers, global.v2);
    global.GuideDaySlider = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _es6Regexp, _es6Date, _es6Object, _construct, _es6Array, _toConsumableArray2, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty3, _dateFns, _enGB, _emotionTheming, _propTypes, _react, _breakpoints, _themes, _ArrowLeft, _ArrowRight, _RedirectionAnchor, _GuideDaySlide, _GuideDaySlider, _dateHelpers, _v) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = _exports.getDayIndex = _exports.getDaysInRange = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _construct = _interopRequireDefault(_construct);
  _toConsumableArray2 = _interopRequireDefault(_toConsumableArray2);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _enGB = _interopRequireDefault(_enGB);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _themes = _interopRequireDefault(_themes);
  _ArrowLeft = _interopRequireDefault(_ArrowLeft);
  _ArrowRight = _interopRequireDefault(_ArrowRight);
  _RedirectionAnchor = _interopRequireDefault(_RedirectionAnchor);
  _GuideDaySlide = _interopRequireDefault(_GuideDaySlide);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var getDaysInRange = function getDaysInRange(from, to) {
    var range = [];
    var currentDate = (0, _dateFns.startOfDay)((0, _v.legacyParse)(from));
    var toDate = new Date(to);

    while (currentDate <= toDate) {
      range.push(currentDate);
      currentDate = (0, _dateFns.addDays)((0, _v.legacyParse)(currentDate), 1);
    }

    return range;
  };

  _exports.getDaysInRange = getDaysInRange;

  var getDayIndex = function getDayIndex(dateRange, currentDay) {
    var initialSlide = -1;
    dateRange.some(function (d, index) {
      var dateEqual = (0, _dateFns.isEqual)((0, _v.legacyParse)(d), (0, _v.legacyParse)(currentDay));

      if (dateEqual) {
        initialSlide = index;
      }

      return dateEqual;
    });
    return initialSlide;
  };

  _exports.getDayIndex = getDayIndex;

  var NextArrow = function NextArrow(_ref) {
    var label = _ref.label,
        onClick = _ref.onClick,
        visible = _ref.visible,
        touchDevice = _ref.touchDevice;
    return /*#__PURE__*/_react.default.createElement(_GuideDaySlider.StyledArrowNext, {
      "aria-hidden": true,
      "aria-label": label,
      visible: visible,
      onMouseUp: onClick,
      tabIndex: -1,
      type: "button",
      touchDevice: touchDevice
    }, /*#__PURE__*/_react.default.createElement(_ArrowRight.default, {
      size: {
        default: 'xsmall',
        medium: 'medium'
      }
    }));
  };

  NextArrow.propTypes = {
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    touchDevice: _propTypes.default.bool,
    visible: _propTypes.default.bool
  };

  var PrevArrow = function PrevArrow(_ref2) {
    var label = _ref2.label,
        onClick = _ref2.onClick,
        visible = _ref2.visible,
        touchDevice = _ref2.touchDevice;
    return /*#__PURE__*/_react.default.createElement(_GuideDaySlider.StyledArrowPrev, {
      "aria-hidden": true,
      "aria-label": label,
      visible: visible,
      onMouseUp: onClick,
      tabIndex: -1,
      type: "button",
      touchDevice: touchDevice
    }, /*#__PURE__*/_react.default.createElement(_ArrowLeft.default, {
      size: {
        default: 'xsmall',
        medium: 'medium'
      }
    }));
  };

  PrevArrow.propTypes = {
    label: _propTypes.default.string,
    onClick: _propTypes.default.func,
    touchDevice: _propTypes.default.bool,
    visible: _propTypes.default.bool
  };

  var GuideDaySlider = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(GuideDaySlider, _PureComponent);

    var _super = _createSuper(GuideDaySlider);

    function GuideDaySlider(props) {
      var _this;

      (0, _classCallCheck2.default)(this, GuideDaySlider);
      _this = _super.call(this, props);
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onChangedMediaQuery", function () {
        _this.setState({
          touchDevice: 'ontouchstart' in global && global.innerWidth < _breakpoints.nextBreakpoints.XLARGE,
          rootOffsetWidth: _this.root.offsetWidth,
          translateWidths: _this.getTranslateWidths()
        }, _this.scrollToSlide);
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onNextArrowClick", function () {
        var focusedSlide = _this.state.focusedSlide;
        var _this$state = _this.state,
            rootOffsetWidth = _this$state.rootOffsetWidth,
            translateWidths = _this$state.translateWidths;
        var maxTranslateX = translateWidths[focusedSlide] - rootOffsetWidth / 2;
        var remainingWidths = translateWidths.slice(focusedSlide + 1);
        remainingWidths.forEach(function (translateX) {
          if (translateX >= maxTranslateX) {
            focusedSlide += 1;
          }
        });

        _this.setState({
          focusedSlide: focusedSlide
        });
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onPrevArrowClick", function () {
        var focusedSlide = _this.state.focusedSlide;
        var _this$state2 = _this.state,
            rootOffsetWidth = _this$state2.rootOffsetWidth,
            translateWidths = _this$state2.translateWidths;
        var maxTranslateX = translateWidths[focusedSlide] + rootOffsetWidth / 2;
        var remainingWidths = translateWidths.slice(0, Math.max(0, focusedSlide));
        remainingWidths.forEach(function (translateX) {
          if (translateX <= maxTranslateX) {
            focusedSlide -= 1;
          }
        });

        _this.setState({
          focusedSlide: focusedSlide
        });
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onDayClick", function (day) {
        if (day !== _this.state.currentDay) {
          var index = getDayIndex(_this.state.dateRange, day);

          _this.setState({
            currentDay: day,
            focusedSlide: index,
            selectedSlide: index
          }, function () {
            setTimeout(function () {
              _this.focusDate();

              _this.scrollToSlide();
            }, 100);
          });

          _this.props.onClick(day);
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onDayFocus", function (day) {
        if (day !== _this.state.currentDay) {
          var index = getDayIndex(_this.state.dateRange, day);

          _this.setState({
            focusedSlide: index
          });
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onSelectedDayFocus", function () {
        if (_this.state.focusedSlide !== _this.state.selectedSlide) {
          _this.setState({
            focusedSlide: _this.state.selectedSlide
          }, function () {
            setTimeout(function () {
              _this.focusDate();

              _this.scrollToSlide();
            }, 250);
          });
        } else {
          _this.focusDate();

          _this.scrollToSlide();
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "onSelectProgram", function () {
        var chosenProgram = global.document.querySelectorAll('.program-timeline');

        if (chosenProgram.length !== 0) {
          if (chosenProgram.length > 1) {
            chosenProgram[1].querySelector('a').focus();
          } else {
            chosenProgram[0].querySelector('a').focus();
          }
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "getTranslateWidths", function () {
        var widths = (0, _toConsumableArray2.default)(_this.root.querySelectorAll("".concat(_GuideDaySlider.StyledSliderSlide, ", ").concat(_GuideDaySlider.StyledSliderSlideCurrent))).map(function (el) {
          return el.offsetWidth;
        });
        var sum = 0;
        return widths.map(function (w) {
          sum += w;
          return _this.root.offsetWidth / 2 - sum + w / 2;
        });
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "focusDate", function () {
        if (_this.root) {
          var chosenDate = _this.root.querySelector("".concat(_GuideDaySlider.StyledSliderSlideCurrent, " > button"));

          chosenDate.focus();
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "scrollToSlide", function () {
        var _this$state3 = _this.state,
            focusedSlide = _this$state3.focusedSlide,
            touchDevice = _this$state3.touchDevice,
            translateWidths = _this$state3.translateWidths;

        if (touchDevice) {
          _this.root.querySelector(_GuideDaySlider.StyledSliderSlides).scrollLeft = Math.abs(Math.min(0, translateWidths[focusedSlide]));
        }
      });
      (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "init", function (root) {
        if (root) {
          _this.root = root;
        }
      });
      var currentDay = (0, _dateFns.startOfDay)((0, _v.legacyParse)(props.currentDate));
      var dateRange = getDaysInRange(props.fromDate, props.toDate);
      var dayIndex = getDayIndex(dateRange, currentDay);
      _this.labels = _objectSpread(_objectSpread({}, props.labels), {}, {
        dayFormat: (0, _dateHelpers.formatLegacyDayFormat)(props.labels.dayFormat)
      });
      _this.state = {
        currentDay: currentDay,
        dateRange: dateRange,
        focusedSlide: dayIndex,
        selectedSlide: dayIndex,
        touchDevice: false,
        rootOffsetWidth: 0,
        translateWidths: Array(dateRange.length).fill(0) // SSR

      };
      return _this;
    }

    (0, _createClass2.default)(GuideDaySlider, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // because of SSR we have to test touchDevice client-side
        // once touchDevice state is updated and re-render is done,
        // we can update translateWidths state
        // (slides width is not the same for touch device and non-touched device)
        this.onChangedMediaQuery();
        this.mediaQueryListM = global.matchMedia('(max-width: 1199px)');
        this.mediaQueryListXL = global.matchMedia('(min-width: 1200px)');
        this.mediaQueryListM.addListener(this.onChangedMediaQuery);
        this.mediaQueryListXL.addListener(this.onChangedMediaQuery);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.mediaQueryListM.removeListener(this.onChangedMediaQuery);
        this.mediaQueryListXL.removeListener(this.onChangedMediaQuery);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            dateLocale = _this$props.dateLocale,
            theme = _this$props.theme;
        var _this$state4 = this.state,
            currentDay = _this$state4.currentDay,
            dateRange = _this$state4.dateRange,
            focusedSlide = _this$state4.focusedSlide,
            selectedSlide = _this$state4.selectedSlide,
            touchDevice = _this$state4.touchDevice,
            translateWidths = _this$state4.translateWidths;
        var style = touchDevice ? {} : {
          transform: "translateX(".concat(translateWidths[focusedSlide], "px)")
        };
        return /*#__PURE__*/_react.default.createElement(_emotionTheming.ThemeProvider, {
          theme: _themes.default[theme]
        }, /*#__PURE__*/_react.default.createElement(_GuideDaySlider.StyledSlider, {
          touchDevice: touchDevice
        }, /*#__PURE__*/_react.default.createElement(_RedirectionAnchor.default, {
          date: currentDay,
          dateLocale: dateLocale,
          focusSelectedDate: this.onSelectedDayFocus,
          focusProgram: this.onSelectProgram,
          programLabel: this.labels.redirectProgram,
          changeDateLabel: this.labels.redirectChooseDate
        }), /*#__PURE__*/_react.default.createElement(PrevArrow, {
          label: this.labels.getPrevDay,
          onClick: this.onPrevArrowClick,
          visible: selectedSlide > 0 || focusedSlide > 0,
          touchDevice: touchDevice
        }), /*#__PURE__*/_react.default.createElement(_GuideDaySlider.StyledSliderWrapper, {
          ref: this.init
        }, /*#__PURE__*/_react.default.createElement(_GuideDaySlider.StyledSliderSlides, {
          style: style
        }, dateRange.map(function (d) {
          return currentDay && (0, _dateFns.isEqual)((0, _v.legacyParse)(d), (0, _v.legacyParse)(currentDay)) ? /*#__PURE__*/_react.default.createElement(_GuideDaySlider.StyledSliderSlideCurrent, {
            key: d.getTime(),
            tabIndex: -1
          }, /*#__PURE__*/_react.default.createElement(_GuideDaySlide.default, {
            isCurrent: true,
            date: d,
            theme: theme,
            dateLocale: dateLocale,
            daysBefore: selectedSlide,
            daysAfter: dateRange.length - selectedSlide - 1,
            labels: _this2.labels,
            onClick: _this2.onDayClick,
            onFocus: _this2.onDayFocus
          })) : /*#__PURE__*/_react.default.createElement(_GuideDaySlider.StyledSliderSlide, {
            key: d.getTime()
          }, /*#__PURE__*/_react.default.createElement(_GuideDaySlide.default, {
            date: d,
            theme: theme,
            dateLocale: dateLocale,
            labels: _this2.labels,
            onClick: _this2.onDayClick,
            onFocus: _this2.onDayFocus
          }));
        }))), /*#__PURE__*/_react.default.createElement(NextArrow, {
          label: this.labels.getNextDay,
          onClick: this.onNextArrowClick,
          visible: selectedSlide < dateRange.length - 1 || focusedSlide < dateRange.length - 1,
          touchDevice: touchDevice
        })));
      }
    }]);
    return GuideDaySlider;
  }(_react.PureComponent);

  GuideDaySlider.propTypes = {
    theme: _propTypes.default.string,
    currentDate: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]),
    fromDate: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]).isRequired,
    toDate: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.instanceOf(Date)]).isRequired,
    dateLocale: _propTypes.default.shape({}),
    labels: _propTypes.default.shape({
      getNextDay: _propTypes.default.string,
      getPrevDay: _propTypes.default.string,
      today: _propTypes.default.string,
      tomorrow: _propTypes.default.string,
      yesterday: _propTypes.default.string,
      dayFormat: _propTypes.default.string,
      infoSelectedDay: _propTypes.default.string,
      redirectProgram: _propTypes.default.string,
      redirectChooseDate: _propTypes.default.string
    }),
    onClick: _propTypes.default.func
  };
  GuideDaySlider.defaultProps = {
    theme: 'next',
    dateLocale: _enGB.default,
    labels: {
      getNextDay: "Show next day's programs",
      getPrevDay: "Show previous day's programs",
      today: 'Today',
      tomorrow: 'Tomorrow',
      yesterday: 'Yesterday',
      dayFormat: 'dd MMMM',
      infoSelectedDay: 'Votre sélection actuelle : %{selectionDate}. Vous pouvez consulter les programmes des %{daysBefore} jours avant et des %{daysAfter} jours après cette date.',
      redirectProgram: 'Passer aux programmes du',
      redirectChooseDate: 'Choisir une autre date'
    },
    onClick: function onClick() {}
  };
  var _default = GuideDaySlider;
  _exports.default = _default;
});